const API_URL = process.env.REACT_APP_API_URL || 'https://onlinestore-backend.innovatorsforge.com/api';

export const API_BASE_URL = API_URL;

// Extract the base domain (without /api) for images and other static assets
export const BASE_URL = API_URL.endsWith('/api') 
  ? API_URL.slice(0, -4) 
  : API_URL;

export default {
  API_BASE_URL,
  BASE_URL
};
